<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5074 10.2393H3.57293C3.13556 10.2393 2.78027 10.5631 2.78027 10.9628C2.78027 11.3626 3.13556 11.6873 3.57293 11.6873H18.5074L12.4693 17.2055C12.1601 17.4881 12.1601 17.9473 12.4693 18.2299C12.7786 18.5125 13.28 18.5125 13.5893 18.2299L20.9804 11.4751C21.0755 11.3882 21.1416 11.2848 21.1786 11.175V11.1741V11.1732V11.1723C21.1986 11.1119 21.2106 11.047 21.2126 10.9811V10.9802V10.9775V10.9766V10.9747V10.9729V10.972V10.9702V10.9674V10.9628C21.2126 10.9619 21.2126 10.9601 21.2126 10.9583V10.9564V10.9546V10.9537V10.951V10.95V10.9491V10.9464V10.9455C21.2106 10.8796 21.1986 10.8147 21.1786 10.7543V10.7525V10.7516C21.1416 10.6418 21.0755 10.5384 20.9804 10.4515L13.5893 3.69671C13.28 3.41408 12.7786 3.41408 12.4693 3.69671C12.1601 3.97934 12.1601 4.43759 12.4693 4.72022L18.5074 10.2393Z"
      fill="#0C0C0C"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardArrowRight'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
